module.exports = __webpack_public_path__ + "img/Young.f0d16ad2.svg";